define([
	"csi/_base/underscore",
	"csi/util",
	"csi/xml",
], function(_,util,xml) {

	/**
	 * Create <Request> XML node with parameters for this request
	 */
	function createXMLForRequests(/*XMLNode*/viewNode, /*ViewContainer*/viewContainer) {
		var requests = _.filter(viewContainer.requests, function(r) { return !!r; });
		if (!requests || requests.length==0)
			return;

		var doc = viewNode.ownerDocument;

		// if we have a custom view, add some info about it
		var pref = viewContainer.pref;
		if (pref) {
			viewNode.setAttribute("CustomViewId",pref.getName() || "Default");
			viewNode.setAttribute("CustomViewURL",pref.urlNode);
			viewNode.setAttribute("CustomViewUserURL",pref.getParty() || "");
		}

		// if we have a cellSpec, add some info about it
		var spec = viewContainer.spec;
		if (spec) {
			viewNode.setAttribute("ColumnQueryKey",spec.queryKey);
		}

		// if we have column filters, add them
		var columnFilterValues = viewContainer.columnFilterValues;
		if (columnFilterValues) {
			var filterValuesNode = xml.e(doc,"Filters",viewNode);
			_.forEach(columnFilterValues,function(columnFilterValue){
				var valueNode = xml.e(doc,"Filter",filterValuesNode);
				valueNode.setAttribute("Key",columnFilterValue.queryKey);
				valueNode.setAttribute("Value",columnFilterValue.value);
			});
		}

		// function to add a <Param> node to <Request> node
		function addParam(requestNode,key,value) {
			var paramNode = xml.e(doc,"Param",requestNode);
			paramNode.setAttribute("Name",key);

			value = String(value);
			if (value && value.indexOf("\n")>=0) {
				paramNode.appendChild(doc.createCDATASection(value));
			} else {
				paramNode.setAttribute("Value",value);
			}
		}

		_.forEach(requests,function(request){
			// add the root <Request> node to the parent <View> node
			var requestNode = xml.e(doc,"Request",viewNode);

			// optimize dependency paths
			request._optimize();

			// iterate over parameters in the request content
			var map = request.content;
			for (var x in map) {
				var y = map[x];
				if (y instanceof Array) {
					for (var i = 0; i < y.length; ++i) {
						addParam(requestNode,x,y[i]);
					}
				} else {
					addParam(requestNode,x,y);
				}
			}
			if (request.binaryKey) {
				addParam(requestNode,request.binaryKey,request.binaryXml);
			}
		});
	}

	return {
		generateXMLDocumentForTypeContainers: function(/*TypeContainer[]*/typeContainers) {
			// summary: output XML script of requests of all views
			var doc = util.newXMLDocument();
			doc.appendChild(doc.createElement("ViewRequests"));

			_.forEach(typeContainers,function(typeContainer){
				var typeName = typeContainer.typeName;

				// create the root <Node> element for the class
				var typeNode = xml.e(doc,"Node",doc.documentElement);
				typeNode.setAttribute("Type",typeName);

				// add this class as <Classes> node
				var classesNode = xml.e(doc,"Classes",typeNode);
				var classNode = xml.e(doc,"Class",classesNode);
				classNode.appendChild(doc.createTextNode(typeName));

				_.forEach(typeContainer.viewContainers,function(viewContainer){
					// create <View> node for the view
					var viewNode = doc.createElement("View");
					viewNode.setAttribute("Id",viewContainer.id);
					viewNode.setAttribute("RootURL",viewContainer.rootNodeURL);
					viewNode.setAttribute("OriginalType",viewContainer.originalType);

					// append the node before calling other functions
					// to allow 'viewNode' to have the correct 'ownerDocument' property
					typeNode.appendChild(viewNode);

					createXMLForRequests(viewNode,viewContainer);
				});
			},this);

			return doc;
		},
	};
});